module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_8019.ce111e38.png";